// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                   from 'firebase/functions';

// ===== Services =====

import getCurrentActionOrigin       from './getCurrentActionOrigin';

// ===== Interfaces =====

import {
    IBookInviteActionResult,
    IResendBookInvitePayload,
}                               from '../interfaces';

const resendBookInvite = async ({
    test,
    assignmentId,
}: {
    test: boolean,
    assignmentId: string,
}): Promise<IBookInviteActionResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        IResendBookInvitePayload,
        IBookInviteActionResult
    >(
        functions,
        'resendBookInvite',
    );
    const actionOrigin = getCurrentActionOrigin();
    const payload: IResendBookInvitePayload = {
        test,
        assignmentId,
    };
    if (actionOrigin) payload.actionOrigin = actionOrigin;
    return callable(payload).then((result) => result.data as IBookInviteActionResult);
};

export default resendBookInvite;
